import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { HeaderTwo, MultiTextLink } from 'secondstep-components'
import Lesson from 'experienceComponents/Lesson'
import LessonAB from 'experienceComponents/LessonAB'
import { LessonListWrapper, SubHeadBox } from './component.styles'

const LessonList = ({
  dataTestId,
  displayAsAccordion,
  gradeTheme,
  lessonItems,
  lessonLastIndex,
  lessonPlanUrl,
  lessonStartingIndex,
  match,
  onDownloadResource,
  setALessonIsOpen,
  setSelectedLessonIndex,
  showLessonsHeader,
  studentHandoutsUrl,
  toggleSelectedLessonAB,
  unitResources,
}) => (
  <LessonListWrapper dataTestId={dataTestId}>
    <SubHeadBox>
      {showLessonsHeader && (
        <HeaderTwo dataTestId="header-lessons">
          {`Lessons ${lessonStartingIndex}-${lessonLastIndex}`}
        </HeaderTwo>
      )}
      {unitResources && (
        <MultiTextLink
          dataTestId="text-link-plans-handouts"
          downloadLinkLabel="All Lesson Plans"
          downloadOnClick={() => onDownloadResource(lessonPlanUrl)}
          textLinkLabel="All Student Handouts"
          textLinkOnClick={() => onDownloadResource(studentHandoutsUrl)}
        />
      )}
    </SubHeadBox>
    {lessonItems.map(
      ({
        hasChoices,
        isLessonDone,
        key,
        lesson,
        lessonChoiceIndex,
        lessonContent,
        lessonIndex,
        listIndex,
        openThisLesson,
        selectedChoice,
      }) => (
        <Fragment key={key}>
          {hasChoices && (
            <LessonAB
              contentfulLesson={lessonContent}
              isOpen={openThisLesson}
              lessonIndex={listIndex}
              toggleSelectedLessonAB={toggleSelectedLessonAB}
            >
              {selectedChoice && (
                <Lesson
                  attempted={selectedChoice.attempted}
                  contentfulLesson={lessonContent}
                  dataTestId={`lesson-${listIndex + 1}`}
                  displayAsAccordion={displayAsAccordion}
                  gradeTheme={gradeTheme}
                  instance={selectedChoice.instance}
                  isDone={isLessonDone}
                  isOpen={openThisLesson}
                  leaf_node_id={selectedChoice.leaf_node_id}
                  lessonIndex={lessonIndex}
                  match={match}
                  scoId={selectedChoice.scoID}
                  selectedLessonABIndex={lessonChoiceIndex}
                  setALessonIsOpen={setALessonIsOpen}
                  setSelectedLessonIndex={setSelectedLessonIndex}
                  v2_class_registration_id={
                    selectedChoice.v2_class_registration_id
                  }
                />
              )}
            </LessonAB>
          )}
          {!hasChoices && (
            <Lesson
              attempted={lesson.attempted}
              contentfulLesson={lessonContent}
              dataTestId={`lesson-${listIndex + 1}`}
              displayAsAccordion={displayAsAccordion}
              gradeTheme={gradeTheme}
              instance={lesson.instance}
              isDone={isLessonDone}
              isOpen={openThisLesson}
              leaf_node_id={lesson.leaf_node_id}
              lessonIndex={lessonIndex}
              match={match}
              scoId={lesson.scoID}
              setALessonIsOpen={setALessonIsOpen}
              setSelectedLessonIndex={setSelectedLessonIndex}
              v2_class_registration_id={lesson.v2_class_registration_id}
            />
          )}
        </Fragment>
      ),
    )}
  </LessonListWrapper>
)

LessonList.propTypes = {
  dataTestId: PropTypes.string.isRequired,
  displayAsAccordion: PropTypes.bool,
  gradeTheme: PropTypes.string,
  lessonItems: PropTypes.arrayOf(
    PropTypes.shape({
      hasChoices: PropTypes.bool.isRequired,
      isLessonDone: PropTypes.bool.isRequired,
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      lesson: PropTypes.object.isRequired,
      lessonChoiceIndex: PropTypes.number,
      lessonContent: PropTypes.object.isRequired,
      lessonIndex: PropTypes.number.isRequired,
      listIndex: PropTypes.number.isRequired,
      openThisLesson: PropTypes.bool.isRequired,
      selectedChoice: PropTypes.object,
    }),
  ).isRequired,
  lessonLastIndex: PropTypes.number.isRequired,
  lessonPlanUrl: PropTypes.string,
  lessonStartingIndex: PropTypes.number.isRequired,
  match: PropTypes.object.isRequired,
  onDownloadResource: PropTypes.func,
  setALessonIsOpen: PropTypes.func.isRequired,
  setSelectedLessonIndex: PropTypes.func.isRequired,
  showLessonsHeader: PropTypes.bool.isRequired,
  studentHandoutsUrl: PropTypes.string,
  toggleSelectedLessonAB: PropTypes.func.isRequired,
  unitResources: PropTypes.array,
}

LessonList.displayName = 'LessonList'

export default LessonList
